import { Feature, Point } from 'geojson';

import { SnMapClusterPoint } from '@lib/api';
import { SnLonLatLike } from '@lib/geo/helpers';

import { EsriMap } from '../../map';
import { IEsriMapMarkerIconLabel } from './marker-options';

export interface IAdvancedEsriIconOptions {
  fontSet?: string;
  fontIcon?: string;
  color?: string;
  url?: string;
  size?: string;
}

export interface IAdvancedEsriStyleOptions {
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeWeight?: number;
  strokeOpacity?: number;
  scale?: number;
  rotation?: number;
}

export interface IAdvancedEsriBadgeOptions {
  right?: string;
  bottom?: string;
  top?: string;
  left?: string;
}

export interface IAdvancedEsriMarkerOptions {
  id?: string;
  position?: SnLonLatLike;
  title?: string;
  draggable?: boolean;
  zIndex?: number;
  map?: EsriMap;

  // Feature-specific options
  feature?: Feature<Point>;
  icon?: IAdvancedEsriIconOptions;
  size?: string;
  color?: string;
  rotation?: number;
  outline?: boolean;
  iconLabel?: IEsriMapMarkerIconLabel;
  styles?: IAdvancedEsriStyleOptions;
  cluster?: SnMapClusterPoint;
  content?: HTMLElement;
  badgePosition?: IAdvancedEsriBadgeOptions;
  layer?: string;
  organization?: string;

  // Axon-specific options
  isAxonLayer?: boolean;
  isAxonDevice?: boolean;
}
